import React from 'react';
import { Chip } from '@mui/material';

export const ProPlanChip: React.FC<{ disabled?: boolean }> = ({ disabled }) => (
	<Chip
		// sensible defaults, individually overridable
		size='small'
		color='primary'
		variant='filled'
		className='card-tag'
		style={disabled ? { filter: 'grayscale(100%)' } : undefined}
		label={
			// Crown and "Pro" label
			<span>
				<i
					className='fa-solid fa-crown'
					style={{ marginRight: 4, color: '#FFD700' }}
				></i>
				Pro
			</span>
		}
	/>
);